import { useTheme } from "vuetify"

export function useThemeWatcher() {
  const { theme } = useUserPreferences()
  const { themes, change: changeTheme } = useTheme()

  const authStore = useAuthStore()
  const { decodedTokenClaims } = storeToRefs(authStore)

  watch(
    theme,
    (newTheme) => {
      if (newTheme && themes.value[newTheme]) {
        changeTheme(newTheme)
        return
      }

      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      const defaultTheme = prefersDark ? "dark" : decodedTokenClaims.value?.domain === DomainType.CIVIL ? "civil" : "light"

      // throw error to prevent infinite loop
      if (!themes.value) {
        throw new Error(`Default theme: ${defaultTheme} does not exists`)
      }

      theme.value = defaultTheme
    },
    { immediate: true },
  )
}
